import Icon, { IconType } from '../icon';
import React from 'react';
import * as css from './arrowtogglebutton.module.scss';
import classNames from 'classnames';

interface ArrowToggleButtonProps {
  iconType: IconType.OpenRowTriangle | IconType.CloseRowTriangle;
  onClick: () => void;
  className?: string;
}

export const ArrowToggleButton: React.FC<
  React.PropsWithChildren<ArrowToggleButtonProps>
> = ({ iconType, onClick, className }) => (
  <button
    id={'show-hierarchy-btn'}
    className={classNames(css.hierarchyButton, className)}
    onClick={onClick}
  >
    <Icon type={iconType} className={css.icon} title="" />
  </button>
);
